import { render, staticRenderFns } from "./Page-Profile.vue?vue&type=template&id=58a37905&"
import script from "./Page-Profile.vue?vue&type=script&lang=js&"
export * from "./Page-Profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports